import {
    Html
} from 'SourceComponent/Html/Html.component';
import { lazyComponentLoader } from 'Util/lazyComponentLoader';

export {
    Html
};

// TODO: implement WidgetFactory
export const WidgetFactory = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget" */
    'Component/WidgetFactory'
), 2);

export default Html;
